<template>
  <main>
    <div class="flex min-h-screen p-4">
      <div class="bg-white rounded-lg shadow-lg w-240 p-4 sticky top-4 h-[calc(100vh-2rem)]">
        <navigation></navigation>
      </div>
      <div class="ml-4 flex-1">
        <div class="bg-white rounded-lg shadow-lg p-4 h-full">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Navigation from '@/components/Navigation.vue'

export default {
  components: {
    Navigation,
  },
}
</script>
